export default __webpack_public_path__ + "static/media/element_42.74d21a59.webp";